import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useTranslation } from 'react-i18next';
export const SelectFacility = (props) => {
    var _a;
    const { t } = useTranslation();
    const { value, menuItems, onChange } = props;
    return (React.createElement(FormControl, { required: true, style: { minWidth: '200px' } },
        React.createElement(InputLabel, { id: "facilityDiv" }, t('施設区分')),
        React.createElement(Select, { labelId: "facilityDiv", value: value, onChange: onChange }, (_a = menuItems) === null || _a === void 0 ? void 0 : _a.map((obj) => {
            return (React.createElement(MenuItem, { key: obj.value, value: obj.value }, obj.text));
        }))));
};
